import * as React from "react"
import { useCallback } from "react"
import { NavLink } from "react-router-dom"
import { ReactChildren } from "ui/types"

type Props = {
    children: ReactChildren,
    icon?: ReactChildren,
    url?: string,
    action?: () => void,
    className?: string,
    blank?: boolean
    onClick?: () => void
}

export const MenuLink = ({
    children,
    icon,
    url = '',
    action = () => {},
    className = '',
    blank = false,
    onClick
}: Props) => {

    className = 'menu-link' + (className ? ' ' + className : '')

    let props = {}
    if (blank) {
        props = {
            target: '_blank',
            rel: 'noopener noreferrer'
        }
    }

    const trigger = useCallback(() => {
        if(onClick) onClick()
    }, [onClick])

    return url ? (
        <NavLink
            end
            to={url}
            className={({ isActive, isPending }) => {
                return (
                    className +
                    (isActive || isPending ? ' menu-link-active' : ' menu-link-idle') +
                    (isPending ? ' opacity-70' : '')
                )
            }}
            {...props}
            onClick={trigger}
        >
            {icon ?? null}
            {children}
        </NavLink>
    ) : (
        <div onClick={action} className={className + ' menu-link-idle'}>
            {icon ?? null}
            {children}
        </div>
    )
}